import React, { useContext } from "react";

import {
  NotificationAdd,
  NotificationsActive,
  Work,
  AccessTime,
  Delete,
  CancelPresentation,
  CheckBox,
} from "@mui/icons-material";

import {
  Button,
  Card,
  CardContent,
  CardActions,
  Alert,
  Box,
} from "@mui/material/";

import { CustomIcons } from "../../../Components/helpers/Helpers";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
import { PermissionContext } from "../../../Components/Context/Context";

import {
  LocalizationProvider,
  DesktopDateTimePicker,
} from "@mui/x-date-pickers";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es";
import LoadingPage from "../../../Components/Common/Loading/LoadingPage";

const AlertsTab = ({
  addDataTab,
  setAddDataTab,
  editDataTab,
  setEditDataTab,
  Editor,
  editorState,
  onEditorChange,
  onSaveShortcut,
  handleCancelDataTabs,
  handleSubmitDataTabs,
  dataCaseNotesAlertsMessages,
  handleDeleteDataTabs,
  setSelectionStyleAlert,
  selectionStyleAlert,
  setDateConfig = () => {},
  dateConfig,
  listReloading = false,
  isSaving = false,
  isTyping = false,
}) => {
  const { can } = useContext(PermissionContext);
  const canDeleteAlert = can?.("cases", "deletealerts");
  const hasAddAlert = can?.("cases", "addalerts");

  const CardAlerts = ({
    lawyer,
    createdAt,
    message,
    alertId,
    alertLawyerId,
    alertCaseId,
  }) => {
    return (
      <Card
        sx={{
          minWidth: 275,
          color: "#3f4a5a",
          // border: "1px solid rgba(240, 223, 180, 0.7)",
          background: "rgba(255, 255, 255, 0.55)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          // boxShadow: "0 2px 12px rgba(180, 124, 18, 0.07)",
          borderRadius: "14px",
          overflow: "hidden",
        }}>
        <CardContent
          className="alignItemsAndLeft"
          sx={{ pb: "12px", pt: "15px", px: "16px" }}>
          <NotificationsActive
            color="warning"
            sx={{ marginRight: "10px", mt: "2px" }}
            className="alignItemsAndLeft blinking"
          />
          <Box
            sx={{
              fontSize: "0.93rem",
              lineHeight: 1.55,
              color: "#4a3f2f",
              "& p": { mt: 0, mb: "0.45rem" },
            }}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </CardContent>
        <CardActions
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            background:
              "linear-gradient(90deg, #ffefc7 0%, #fff5dd 40%, #ffffff 100%)",
            padding: "3px 16px",
            // borderTop: "1px solid #f1e4c4",
          }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
              color: "#7c6a4a",
              fontSize: "0.84rem",
            }}>
            <Work sx={{ fontSize: "1rem" }} />
            {lawyer && !lawyer.includes("undefined") ? lawyer : ""}

            <AccessTime sx={{ fontSize: "1rem" }} />
            {createdAt ? dayjs(createdAt).format("DD/MM/YYYY HH:mm") : ""}
          </div>
          {/* Botones opcionales */}
          {!editDataTab && (
            <div>
              {/* <Button
                 color="info"
                 size="small"
                 onClick={() => {
                   setEditDataTab(true);
                   setAddDataTab(true);
                   setAlertId(alertId);
                   setSelectionStyleAlert(alertId);
                   setAlertLawyerId(alertLawyerId);
                   setAlertCaseId(alertCaseId);
                   handleEditEditorDataTabs(message);
                 }}
               >
                 <Edit />
                 Editar
               </Button> */}
              {canDeleteAlert && (
                <Button
                  color="error"
                  size="small"
                  onClick={() =>
                    handleDeleteDataTabs(alertId, message, "alerts", "alerta")
                  }>
                  <CustomIcons
                    icon={Delete}
                    width={"20px"}
                    height={"20px"}
                    marginRight={"5px"}
                  />
                  <span className="reOrderTextButton">Eliminar</span>
                </Button>
              )}
            </div>
          )}
        </CardActions>
      </Card>
    );
  };

  const handleChangeAlertDate = (newValue) => {
    if (!newValue) return;

    setDateConfig(dayjs(newValue));
  };

  return (
    <Box>
      <Box sx={{ textAlign: "right", marginY: "10px" }}>
        {addDataTab !== true && editDataTab !== true && hasAddAlert && (
          <CustomButtonPlusIcon
            color={"warning"}
            icon={NotificationAdd}
            text={"Agregar Alerta"}
            handleFunction={() => setAddDataTab(true)}
            position="start"
            variant={"contained"}
          />
        )}
      </Box>
      {addDataTab ? (
        <Box
          sx={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            mb: "10px",
          }}>
          <Box sx={{ width: "100%", my: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
              <DesktopDateTimePicker
                label="Fecha y hora de la alerta"
                value={dateConfig}
                onChange={handleChangeAlertDate}
                sx={{ width: "100%" }}
                ampm={false} // formato 24h
              />
            </LocalizationProvider>
          </Box>
          <div
            style={{
              border: "1px solid #ddd",
              minHeight: "160px",
              marginBottom: "10px",
              padding: "10px",
              borderRadius: "10px",
            }}>
            <Editor
              editorState={editorState}
              onEditorStateChange={onEditorChange}
              onSaveShortcut={onSaveShortcut}
              toolbar={{
                options: ["inline", "fontSize", "list", "textAlign", "history"],
              }}
            />
          </div>

          {(editDataTab || addDataTab) && (
            <div
              style={{
                textAlign: "end",
                marginBottom: "20px",
                gap: 20,
                display: "flex",
                justifyContent: "end",
              }}>
              {addDataTab && !editDataTab && (
                <CustomButtonPlusIcon
                  color={"error"}
                  icon={CancelPresentation}
                  text={"Cancelar Alerta"}
                  handleFunction={() => handleCancelDataTabs(false)}
                  position="start"
                  variant={"outlined"}
                />
              )}

              {editDataTab && (
                <CustomButtonPlusIcon
                  color={"error"}
                  icon={CancelPresentation}
                  text={"Cancelar Edición"}
                  handleFunction={() => handleCancelDataTabs(false)}
                  position="start"
                  variant={"outlined"}
                />
              )}

              <CustomButtonPlusIcon
                color={"success"}
                icon={CheckBox}
                text={
                  isSaving
                    ? "GUARDANDO..."
                    : editDataTab
                      ? "GUARDAR EDICIÓN"
                      : "GUARDAR ALERTA"
                }
                handleFunction={() =>
                  handleSubmitDataTabs("alerts", "Alerta", {
                    date: dateConfig
                      ? dayjs(dateConfig).format("YYYY-MM-DD HH:mm:ss")
                      : null,
                  })
                }
                position="start"
                variant={"contained"}
                id="alertmessage"
                disabled={isSaving || isTyping}
              />
            </div>
          )}
        </Box>
      ) : (
        ""
      )}

      <Box
        sx={{
          maxHeight: "700px",
          overflowY: "auto",
          borderRadius: "10px",
          px: "12px",
          pb: "20px",
        }}>
        {/* <Typography variant="body2">Alertas</Typography> */}
        {listReloading ? (
          <LoadingPage isLoading={true} heightProp="280px" />
        ) : dataCaseNotesAlertsMessages?.alerts?.length > 0 ? (
          dataCaseNotesAlertsMessages?.alerts?.map((element, index) => (
            <li
              key={index}
              style={{
                listStyle: "none",
                borderRadius: "10px !important",
                marginTop: "8px",
              }}>
              <CardAlerts
                alertsCaseId={element.case_id}
                alertsLawyerId={element.lawyer_relation?.id}
                lawyer={`${element?.lawyer_relation?.name || ""} ${element?.lawyer_relation?.surname || ""}`.trim()}
                createdAt={element?.date}
                message={element?.message}
                alertId={element?.id}
              />
            </li>
          ))
        ) : (
          <Alert severity="info">Sin alertas para mostrar</Alert>
        )}
      </Box>
    </Box>
  );
};

export default AlertsTab;
